<div class="chat-details">
  <chat-details-header class="chat-details__header" [title]="chat?.chatName" (close)="onClose()"></chat-details-header>

  <chat-administrations-list
    *ngIf="chat?.chatType === 'publicChat'; else membersList"
    class="chat-details__members-list"
    [chatId]="chat?.chatId"
    [permissions]="permissions"
  ></chat-administrations-list>

  <ng-template #membersList>
    <chat-members-list
      class="chat-details__members-list"
      [chatId]="chat?.chatId"
      [permissions]="permissions"
    ></chat-members-list>
  </ng-template>
</div>
